import React from 'react'
import './Category_card.css'
function Category_card(props) {
    return (
        <>
            <section className='Category_card'  onClick={props.onClick}>
                <div className="img_holder">
                    <img src={props.img} alt="category_img" className='category_img'/>
                </div>
                <div className='text_holder'>
                    <p>{props.label}</p>
                    <div className="bg_img_holder">
                        <img src="/assets/images/categories/bg/chicken.png" alt="bg " className='bg_img' />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Category_card